import { mapActions, mapGetters, mapState } from 'vuex'
import axios from 'axios'

// Mixin for checking new credit card payment
export const orderMixin = {
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      order: 'orderDetail/getOrderDetail',
      payment: 'payment/getPayment',
      state: 'orderDetail/getState'
    }),
    ...mapState('payment', [
      'tmpOmiseChargeId',
      'tmpOmiseToken',
      'tmpIsDefaultCard'
    ])
  },
  watch: {
    async payment () {
      // Check added user credit card to perform payment based on actions
      let action = null
      if (this.payment) {
        action = this.$route.query.action
        switch (action) {
          case 'professional_booking_payment': {
            // Add credit card payment
            const submitData = {
              order_id: this.order.id,
              user_id: this.user.id,
              omise_token: ''
            }
            await this.$store.dispatch('orderDetail/ADD_CREDIT_CARD_PAYMENT', submitData)
            const alertMessage = this.$i18n.t('message.payment_method.payment_success')
            this.$swal({text: alertMessage, type: 'success'})
          }
            break
          case 'additional_hours_booking_payment': {
            // Add additional hours
            const tmpData = this.state.tmpAdditionalHoursBookingData
            if (tmpData) {
              const submitData = {
                user_id: tmpData.user_id,
                order_id: tmpData.order_id,
                service_id: tmpData.service_id,
                work_hour: tmpData.work_hour,
                payment_method: tmpData.payment_method
              }
              const url = (!tmpData.order_additional_hours_id) ? 'order-additional-hours' : `order-additional-hours/${tmpData.order_additional_hours_id}/update-payment`
              const {data} = await axios.post(url, submitData)
              if (!data.error) {
                const alertMessage = this.$i18n.t('message.payment_method.payment_success')
                this.$swal({text: alertMessage, type: 'success'})
              } else {
                this.$swal({text: data.message, type: 'error'})
              }
            }
          }
            break
          case 'service_purchase_payment': {
            // Add service purchase
            const tmpData = this.state.tmpPurchaseServiceData
            if (tmpData) {
              const submitData = {
                user_id: tmpData.user_id,
                order_id: tmpData.order_id,
                service_id: tmpData.service_id,
                amount: tmpData.amount,
                total_price: tmpData.total_price,
                service_vat: tmpData.service_vat,
                product_type: tmpData.product_type,
                payment_method: tmpData.payment_method
              }
              const url = '/purchases/service'
              const {data} = await axios.post(url, submitData)
              this.$store.commit('orderDetail/SET_TMP_PURCHASE_SERVICE_DATA', null)
              if (!data.error) {
                const alertMessage = this.$i18n.t('message.payment_method.payment_success')
                this.$swal({text: alertMessage, type: 'success'})
              } else {
                this.$swal({text: data.message, type: 'error'})
              }
            }
          }
            break
          case 'professional_tip_payment': {
            // Add professional tip
            const tmpData = this.state.tmpProfessionalTipData
            if (tmpData) {
              const {data} = await axios.post('/professional-tips', tmpData)
              if (!data.error) {
                await this.loadOrderDetail(this.order.id)
                this.$swal({
                  imageUrl: '/static/img/thank-give-tip.png',
                  imageHeight: 180,
                  title: this.$i18n.t('message.professional_tip.thank_dialog_title'),
                  text: this.$i18n.t('message.professional_tip.thank_dialog_message'),
                  confirmButtonColor: '#17a2b8'
                })
              } else {
                this.$swal({text: data.message, type: 'error'})
              }
            }
          }
            break
        }
      }
      // Clear query params to prevent charging credit card if user refreshes web page
      const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)
      if (action && !isSafari) {
        let query = Object.assign({}, this.$route.query)
        delete query.tmpToken
        delete query.action
        this.$router.replace({ query })
      }
    }
  },
  methods: {
    ...mapActions('orderDetail', ['loadOrderDetail']),
    async checkOmiseTestCharge () {
      const url = `/payments/${this.user.id}/check-omise-test-charge`
      const { data } = await axios.post(url, { omise_charge_id: this.tmpOmiseChargeId })
      if (data) {
        const omiseTestCharge = data.omise_test_charge
        switch (omiseTestCharge.status) {
          case 0:
            setTimeout(() => {
              this.checkOmiseTestCharge()
            }, 2000)
            break
          case 1:
            this.saveNewCard()
            break
          case 2:
            this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
            const message = `${this.$i18n.t('message.booking.payment_step.payment_cannot_save_credit_card')} ${omiseTestCharge.failure_message}`
            this.$swal({ text: message, type: 'error' })
            break
        }
      }
    },
    async saveNewCard () {
      // Add new card
      const submitData = {
        user_id: this.user.id,
        omise_token: this.tmpOmiseToken,
        is_default: this.tmpIsDefaultCard
      }
      await this.$store.dispatch('payment/ADD_PAYMENT', submitData)
    }
  },
  async mounted () {
    // Check credit card payment for new card
    if (this.$route.query.tmpToken && this.$route.query.tmpToken === this.tmpOmiseToken) {
      if (this.$route.query.action && this.tmpOmiseToken) {
        // Check omise test charge
        this.checkOmiseTestCharge()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/orderMixin.js